import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetVehicle from '../hooks/useGetVehicle';
import CollapsibleGroup from '../ui/CollapsibleGroup';

const VehicleDescription = ({ className }) => {
  const { t } = useTranslation('details');
  const { vehicle } = useGetVehicle();

  return (
    <div className={className}>
      <CollapsibleGroup title={t('Description')}>
        <p className="px-2 lg:px-0 mb-2">{vehicle.description}</p>
      </CollapsibleGroup>
    </div>
  );
};

VehicleDescription.propTypes = {
  className: PropTypes.string,
};

VehicleDescription.defaultProps = {
  className: '',
};

export default VehicleDescription;
